import React, { useEffect, useState } from "react";
import { statsClientes } from "../api";
import "./ClienteMesTab.css";

export default function ClientesMesTab({ mes, setMes }) {
  const [creados, setCreados] = useState([]);
  const [citas, setCitas] = useState([]);
  const [totalCreados, setTotalCreados] = useState(0);
  const [totalCitas, setTotalCitas] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!mes) return;

    setLoading(true);
    statsClientes(mes)
      .then((data) => {
        setCreados(data.creados.items);
        setTotalCreados(data.creados.total);
        setCitas(data.citas.items);
        setTotalCitas(data.citas.total);
        setError("");
      })
      .catch((e) => setError(String(e)))
      .finally(() => setLoading(false));
  }, [mes]);

  return (
    <div className="clientes-tab">
      <h3>👥 Clientes — {mes}</h3>

      <label>
        Mes:
        <input type="month" value={mes} onChange={(e) => setMes(e.target.value)} />
      </label>

      {loading ? (
        <p>Cargando...</p>
      ) : error ? (
        <p className="error">{error}</p>
      ) : (
        <>
          {/* TABLA 1: Clientes creados */}
          <h4>🆕 Clientes creados en el mes ({totalCreados})</h4>

          <div className="pv-table-wrapper">
            <table className="pv-table">
              <thead>
                <tr>
                  <th>Cliente</th>
                  <th>Fecha creación</th>
                </tr>
              </thead>
              <tbody>
                {creados.map((c) => (
                  <tr key={c.id}>
                    <td>{c.nombre} {c.apellidos}</td>
                    <td>{c.creado}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* TABLA 2: Clientes con sesiones */}
          <h4 style={{ marginTop: "2rem" }}>
            📅 Clientes con sesiones en el mes ({totalCitas})
          </h4>

          <div className="pv-table-wrapper">
            <table className="pv-table">
              <thead>
                <tr>
                  <th>Cliente</th>
                  <th>Nº sesiones</th>
                </tr>
              </thead>
              <tbody>
                {citas.map((c) => (
                  <tr key={c.patient_id}>
                    <td>{c.nombre} {c.apellidos}</td>
                    <td>{c.sesiones}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
}
